/* get_query_param.js - get the value of a query param */

/* Copyright (c) 2025 - present Tikkl Inc. */

/*
modification history
--------------------
01a,06oct25,mno  created.
*/

export default function getQueryParam(name){
  if (typeof window === "undefined") return "";
  const queryParams = new URLSearchParams(window.location.search)
  return queryParams.get(name);
}
